import Spinner from "../../../../Components/Loader/Spinner";
import Table from "../../../../Components/Table/Table";

export default function PositionsList({
  rows,
  closingPositionId,
  onClose,
  onEdit,
}) {
  return (
    <div className="hidden min-h-0 flex-1 mb:flex-initial mb:flex mb:flex-col">
      <Table
        isEnglish={[7]}
        isLTR={true}
        haveScroll={true}
        maxHeight="260px"
        columns={[
          { key: "date", label: "زمان ورود" },
          { key: "symbol", label: "نماد" },
          { key: "side", label: "ساید" },
          { key: "type", label: "نوع" },
          { key: "entryPrice", label: "قیمت ورود" },
          { key: "totalCost", label: "حجم" },
          { key: "takeProfit", label: "حد سود" },
          { key: "stopLoss", label: "حد ضرر" },
          {
            key: "pnl",
            label: "سود",
            render: (value, row) => {
              if (row.numberPnl && row.numberPnl > 0) {
                return (
                  <div className="py-1 px-2 rounded-md bg-zi-green-dark/10 ring-1 ring-inset ring-zi-green-dark text-zi-green-dark">
                    <p style={{ direction: "ltr" }}>{value}</p>
                  </div>
                );
              }

              if (row.numberPnl && row.numberPnl < 0) {
                return (
                  <div className="py-1 px-2 rounded-md bg-zi-red-dark/10 ring-1 ring-inset ring-zi-red-dark text-zi-red-dark">
                    <p style={{ direction: "ltr" }}>{value}</p>
                  </div>
                );
              }

              return (
                <div className="py-1 px-2 rounded-md">
                  <p style={{ direction: "ltr" }}>{value}</p>
                </div>
              );
            },
          },
          {
            key: "operation",
            label: "عملیات",
            render: (value, row) =>
              value && (
                <div className="justify-center items-center flex gap-5 [direction:ltr]">
                  <button
                    type="button"
                    onClick={() => onClose(row.id)}
                    disabled={closingPositionId === String(row.id)}
                    className={`min-w-8 inline-flex justify-center disabled:cursor-wait ${
                      closingPositionId === String(row.id)
                        ? ""
                        : "underline underline-offset-2 text-amber-400 hocus:underline-offset-8"
                    }`}
                  >
                    {closingPositionId === String(row.id) ? (
                      <Spinner size="20" color="#fbbf24" stroke="3" />
                    ) : (
                      "بستن"
                    )}
                  </button>
                  <button
                    type="button"
                    className="underline underline-offset-2 hocus:underline-offset-8"
                    onClick={() => onEdit(row)}
                  >
                    ویرایش
                  </button>
                </div>
              ),
          },
        ]}
        data={rows}
      />
    </div>
  );
}
